import React, { useEffect, useState } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useNavigate } from "react-router-dom";
import kampudecte from "../../Assests_Url/kampudecte.png";
import ksmaccudecat from "../../Assests_Url/ksmaccudecat.png";
import katboueduc from "../../Assests_Url/katboueduc.png";
import katbooksmall from "../../Assests_Url/katbooksmall.png";
import pen from "../../Assests_Url/pen.svg";
import lock from "../../Assests_Url/ic_round-lock.svg";
import graduation from "../../Assests_Url/stash_graduation-cap-solid.svg";
import university from "../../Assests_Url/fa_university.svg";
import studen from "../../Assests_Url/studen.png";
import Teachers from "../../Assests_Url/teach.png";
import Parents from "../../Assests_Url/parent.png";
import Schools from "../../Assests_Url/schoo.png";

const UEducate = ({ RoutesClick, NcertClick }) => {
  const [registerModal, setRegisterModal] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [activeTabHeader, setActiveTabHeader] = React.useState("UEducate");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);

  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  return (
    <div>
      <Header
        activeTab={activeTabHeader}
        handleTabClick={handleTabClickHeader}
        studentregisterModal={studentregisterModal}
        setStudentRegisterModal={setStudentRegisterModal}
        ParentregisterModal={ParentregisterModal}
        setParentRegisterModal={setParentRegisterModal}
        TeacherregisterModal={TeacherregisterModal}
        setTeacherregisterModal={setTeacherregisterModal}
        registerModal={registerModal}
        setRegisterModal={setRegisterModal}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
      />
      <div>
        <div className="bannerImgUeducate">
          <div className="bannerOverlayUE">
            <div className="ue1">
              “UEducate — Powering the Future of Learning”
            </div>

            <div className="ue2">
              “We blend content, technology, and pedagogy to create joyful,
              inclusive, and intelligent learning ecosystems.”
            </div>

            <div className="ueducatregbutt">
              <button className="registerBtn mt-4">
                Register now &nbsp; &rarr;
              </button>
            </div>
          </div>
        </div>

        <div className="padthree">
          <div className="ue3">Our Story</div>

          <div className="ue4">
            U-Educate was founded with a simple belief:{" "}
            <span className="ue5">Education must evolve with the Learner</span>.
            Traditional textbooks served generations well, but today’s students
            need more —{" "}
            <span className="ue5">
              Interactive, Engaging, and Personalised Tools
            </span>
            .
          </div>
          <div className="ue4">
            From a small team of innovators to partnerships with{" "}
            <span className="ue5">NCERT, DIKSHA, and state governments</span>,
            UEducate has grown into a{" "}
            <span className="ue5">trusted national EdTech partner</span>,
            impacting{" "}
            <span className="ue5">
              thousands of schools and lakhs of students
            </span>
            .
          </div>
        </div>

        <div className="padtopbotUeduc">
          <div className="ue6">
            <div className="ue7">Our Vision</div>
            <div className="ue8">
              To make education joyful, inclusive, and future-ready for every
              learner.”
            </div>
            <div className="ue7 pt-3">Our Mission</div>
            <div className="ue8">
              Transform static textbooks into smart, interactive learning
              ecosystems.
            </div>
            <div className="ue8">
              Empower teachers with time-saving, classroom-ready tools.
            </div>
            <div className="ue8">
              Provide parents with transparent insights into progress.
            </div>
            <div className="ue8">
              Partner with governments, boards, and schools to scale education
              innovation nationwide.
            </div>
          </div>
        </div>

        <div className="borderBotts" />

        <div className="padfivethree">
          <div className="ue9">What We Do?</div>
          <div className="d-flex justify-content-between align-items-center gap20">
            <div className="d-flex flex-column justify-content-center gap15">
              <div>
                <img src={kampudecte} alt="" />
              </div>
              <div className="ue10">
                A School Information & Learning Management System for academics,
                assessments, attendance, and library management.
              </div>
            </div>
            <div className="divider"></div>
            <div className="d-flex flex-column justify-content-center gap15">
              <div>
                <img src={katboueduc} alt="" />
              </div>
              <div className="ue10">
                NCERT’s next-generation digital textbooks with audio, video,
                AR/VR, practice tools, and analytics.
              </div>
            </div>
            <div className="divider"></div>
            <div className="d-flex flex-column justify-content-center gap15">
              <div>
                <img src={ksmaccudecat} alt="" />
              </div>
              <div className="ue10">
                A secure communication and collaboration platform for schools,
                teachers, students, and parents.
              </div>
            </div>
          </div>
        </div>

        <div className="padtwetytwo">
          <div className="ue11">
            <span className="ue12">AI & Analytics</span> — Smart search,
            translations, coverage reports, and performance dashboards for
            data-driven learning.
          </div>
        </div>

        <div className="borderBotts" />

        <div className="padfivethree20">
          <div className="ue13">Global Vision</div>
          <div className="ue14">
            While our roots are in India’s classrooms, our mission is global.
          </div>
          <div className="ue14">
            We aim to expand U-Educate’s platforms to{" "}
            <span className="ue15">
              International schools and developing nations, offering affordable,
              scalable, and inclusive solutions for the future of learning.
            </span>
          </div>
        </div>

        <div className="padfivethree20">
          <div className="ue13">Our Solution</div>
          <div className="ue14">
            At UEducate, we believe in building{" "}
            <span className="ue15">
              end-to-end digital ecosystems for education
            </span>
            —where{" "}
            <span className="ue15">content, technology, and communication</span>{" "}
            come together to transform learning.
          </div>
          <div className="ue14">
            Our solutions are designed to empower{" "}
            <span className="ue15">
              students, teachers, schools, and parents
            </span>{" "}
            with tools that are{" "}
            <span className="ue15">
              interactive, inclusive, and future-ready
            </span>
          </div>
        </div>

        <div className="padfivethree20">
          <div className="ue16">Key Offerings</div>

          <div className="py-3">
            <div className="ue17">
              <img
                src={katbooksmall}
                alt="kampus"
                className="maritoo pensize"
              />
              KATBOOK
            </div>

            <div className="ue18 padd10">
              NCERT’s next-generation digital textbook platform with audio,
              video, 3D/AR/VR, translations, exercises, and analytics.
            </div>
          </div>

          <div className="py-3">
            <div className="ue17">
              <img src={pen} alt="kampus" className="maritoo pensize" />
              KAMPUS
            </div>

            <div className="ue18 padd10">
              Smart School Information System (SIS) for managing academics,
              administration, finance, and student records.
            </div>
          </div>

          <div className="py-3">
            <div className="ue17">
              <img src={lock} alt="kampus" className="maritoo pensize" />
              KSMACC
            </div>

            <div className="ue18 padd10">
              A secure communication platform for schools, ensuring safe and
              transparent parent–teacher engagement.
            </div>
          </div>

          <div className="py-3">
            <div className="ue17">
              <img src={graduation} alt="kampus" className="maritoo pensize" />
              LMS (Learning Management System)
            </div>

            <div className="ue18 padd10">
              A flexible digital classroom solution for course delivery,
              assignments, and assessments.
            </div>
          </div>

          <div className="py-3">
            <div className="ue17">
              <img src={university} alt="kampus" className="maritoo pensize" />
              University & Vocational Platforms
            </div>

            <div className="ue18 padd10">
              Scalable solutions for higher education and skill-based training.
            </div>
          </div>
        </div>

        <div className="padfivethree20">
          <div className="ue16 solution-title">Why our Solution?</div>

          <div className="solution-grid">
            <div className="solution-card">
              {" "}
              <div className="solution-image-wrapper">
                {" "}
                <img
                  src={studen}
                  alt="For Students"
                  className="solution-image"
                />
                <div className="solution-image-text">For Students</div> {" "}
              </div>{" "}
              <div className="solution-content">
                {" "}
                <div className="solution-description">
                  Joyful, interactive, and personalised learning
                </div>{" "}
              </div>
            </div>

            <div className="solution-card">
              {" "}
              <div className="solution-image-wrapper">
                {" "}
                <img
                  src={Teachers}
                  alt="For Students"
                  className="solution-image"
                />
                <div className="solution-image-text">For Teachers</div> {" "}
              </div>{" "}
              <div className="solution-content">
                <div className="solution-description">
                  Smarter teaching tools and structured lesson support
                </div>{" "}
              </div>
            </div>

            <div className="solution-card">
              {" "}
              <div className="solution-image-wrapper">
                {" "}
                <img
                  src={Schools}
                  alt="For Students"
                  className="solution-image"
                />
                <div className="solution-image-text">For Schools</div> {" "}
              </div>{" "}
              <div className="solution-content">
                <div className="solution-description">
                  Simplified management, reduced paperwork, and real-time
                  analytics.
                </div>{" "}
              </div>
            </div>

            <div className="solution-card">
              {" "}
              <div className="solution-image-wrapper">
                {" "}
                <img
                  src={Parents}
                  alt="For Students"
                  className="solution-image"
                />
                <div className="solution-image-text">For Parents</div> {" "}
              </div>{" "}
              <div className="solution-content">
                <div className="solution-description">
                  Transparent, secure updates on their child’s progress.
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer
        setActiveTab={setActiveTabHeader}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
      />
    </div>
  );
};

export default UEducate;
